// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__3b7Be","RightSide":"Post_RightSide__3ypV5","Content":"Post_Content__1wFtc","PostWrapper":"Post_PostWrapper__3U9EC","Button":"Post_Button__3N3pu"};